import * as t from "io-ts";

export const codec = t.type({
    id: t.string,
    name: t.string,
    url: t.string,
});

export type T = t.TypeOf<typeof codec>;
